import {authGuard} from '@common/auth/guards/auth-route';
import {RouteObject} from 'react-router';

// every backing endpoint (AdminWorkspaceTriggersController,
// AdminCustomFieldsController, AdminInvitationsController) aborts unless the
// user has the super admin "admin" permission, which "admin.access" on the
// parent /admin route does not imply. Without this guard a staff admin gets a
// 403 rendered as an empty "nothing here yet" table instead of being denied.
const adminGuard = () => authGuard({permission: 'admin'});

export const adminAutomationsRoutes: Record<string, RouteObject> = {
  automations: {
    path: 'automations',
    loader: adminGuard,
    lazy: () => import('@app/admin/automations/admin-trigger-index-page'),
  },
  customFields: {
    path: 'custom-fields',
    loader: adminGuard,
    lazy: () => import('@app/admin/automations/admin-custom-field-index-page'),
  },
  invitations: {
    path: 'invitations',
    loader: adminGuard,
    lazy: () => import('@app/admin/automations/admin-invitations-page'),
  },
  invitationsActivity: {
    path: 'invitations/activity',
    loader: adminGuard,
    lazy: () =>
      import('@app/admin/automations/admin-invitations-activity-page'),
  },
};
